import { Component, effect, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { baseCustomPanelStructureComponent } from '../../new-custom-panel/baseCustomPanelStructure';
import { WidgetService } from '../../../services/builder/widget.service';
import { StaticTextCustomization } from './staticitext-edit';
import { EditorModule } from 'primeng/editor';
import { UniqueIdService } from '../../../services/builder/unique-id.service';

@Component({
  selector: 'lib-statictext-custom-panel',
  template: `
    <lib-base-cpanel
      [content]="content"
      [hideAutocompletion]="true"
      [form]="customizationForm"
      header="Personalizzazione Testo Statico"
      (closed)="updateWidget($event)"
    />
    <ng-template #content>
      @if (customizationForm) {
        <div [formGroup]="customizationForm" class="flex w-full flex-col gap-2">
          <div class="flex w-full flex-col">
            <label for="desc">Descrizione</label>
            <p-editor
              id="desc"
              formControlName="description"
              [formats]="formats"
              [style]="{ height: '200px' }"
            ></p-editor>
          </div>
        </div>
      }
    </ng-template>
  `,
  imports: [
    ReactiveFormsModule,
    baseCustomPanelStructureComponent,
    EditorModule,
  ],
})
export class StaticTextCPanelComponent {
  private fb = inject(FormBuilder);
  protected widgetService = inject(WidgetService<StaticTextCustomization>);
  protected uniqueIdService = inject(UniqueIdService);

  protected customizationForm = this.fb.group({
    id: [
      '',
      [
        Validators.required,
        this.uniqueIdService.forbiddenIdValidator(
          this.widgetService.uniqueId ?? '',
        ),
        this.uniqueIdService.isEmptySpace(),
      ],
    ],
    description: [''],
    showIfRule: ['', [this.uniqueIdService.idNotExistsValidator()]],
  });

  // IMPORTANT: NON includere 'background' (e nemmeno 'color' se vuoi)
  formats = [
    'bold',
    'italic',
    'underline',
    'list',
    'link',
    'color', // <- lascia fuori se non vuoi nemmeno il colore
    // 'background',  // <- lascia fuori per evitare background-color
  ];

  constructor() {
    effect(() => {
      const widget = this.widgetService.widget();
      if (!widget) return;

      const uniqueId = this.widgetService.uniqueId;
      if (!uniqueId) return;

      this.customizationForm.patchValue({
        id: uniqueId,
        description: widget.customization.description,
        showIfRule: widget.customization.showIfRule,
      });
    });
  }

  updateWidget(event: boolean) {
    if (!event) {
      this.widgetService.settingVisibility.set(false);
      return;
    }

    const formValue = this.customizationForm.value;
    const id = formValue.id?.trim();
    if (!id) return;

    this.widgetService.updateWidget(id, {
      description: formValue.description,
      showIfRule: formValue.showIfRule || '',
    });
    this.widgetService.settingVisibility.set(false);
  }
}
